import { createInstantLiveMeet } from './liveMeetApi';

/**
 * Instant Live Meet: creates a persisted booking + LiveKit room via POST /api/meeting/live-meet/instant.
 * Instant uses direct candidate join and does not send confirmation emails (share link manually).
 * Manual scheduled Live Meet uses approval-required join and sends confirmation emails.
 */
export async function startInstantOpenLinkLiveMeet({
  jobId,
  jobTitle,
  candidateEmail,
  candidateName,
  interviewerEmail,
  interviewerName,
  additionalInterviewers,
  interviewerIsCohost = false,
  companyName,
  interviewRound = 'technical_round_1',
  transcriptEnabled = true,
  clientRequestId,
}) {
  const job_id = String(jobId || '').trim();
  const candidate_email = String(candidateEmail || '').trim();
  const interviewer_email = String(interviewerEmail || '').trim().toLowerCase();

  if (!job_id) {
    throw new Error('Job id is missing for this candidate.');
  }
  if (!candidate_email) {
    throw new Error('Candidate email is required.');
  }
  if (!interviewer_email) {
    throw new Error('At least one interviewer email is required.');
  }

  const additional_interviewers = (Array.isArray(additionalInterviewers) ? additionalInterviewers : [])
    .map((entry) => ({
      email: String(entry?.email || '').trim().toLowerCase(),
      name: (entry?.name || '').trim(),
      is_cohost: Boolean(entry?.is_cohost),
    }))
    .filter((entry) => entry.email);

  const response = await createInstantLiveMeet({
    job_id,
    job_title: jobTitle || 'Live Interview',
    meeting_title: jobTitle || 'Live Interview',
    candidate_email,
    candidate_name: candidateName || candidate_email,
    interviewer_email,
    interviewer_name: interviewerName || interviewer_email,
    interviewer_is_cohost: Boolean(interviewerIsCohost),
    additional_interviewers,
    company_name: String(companyName || '').trim() || undefined,
    interview_round: String(interviewRound || '').trim() || 'technical_round_1',
    transcript_enabled: transcriptEnabled,
    client_request_id: clientRequestId || undefined,
  });

  return {
    roomPayload: response?.booking?.live_room || null,
    booking: response?.booking || null,
  };
}
